<template>
  <div class="else_view">
    <div v-if="!chiceAfter" :class="schoolShowFlag?'login_popup else_popup login_popup_c':'login_popup else_popup'">
      <div class="stu_box">
        <div class="choice">
          <div class="close_btn" @click="closeList()">
            <img
              style="width:24px;height:24px;"
              src="../../src/images/login/ico_close.svg"
              alt
            />
          </div>
          <div class="login_tit else_title">
            <ul class="qrcode_tit clear_margin">
              <li>选择学校</li>
            </ul>
            <div class="school_inp">
              <div class="school_inp_img">
                <img
                  style="width:16.3px;height:16.3px;"
                  src="../../src/images/login/seach.svg"
                  alt
                />
              </div>
              <input type="text" v-model="schoolSearch" @input="searchTo()" placeholder="输入学校名称进行搜索"/>
            </div>
          </div>
        </div>
        <div class="choice_school">
          <span v-if="schoolList.length > 10" class="school_left cursor_p" @click="toLeft()">
            <img style="width:40px;height:50px;" :src="isLeft?require('../images/login/left.svg'):require('../images/login/left_gray.svg')" alt/>
          </span>
          <div class="school_box">
            <div v-if="schoolList.length > 10" class="school_list">
              <dl
                v-for="(item,index) in schoolList.slice(start,end)"
                @click="toNextPage(item)"
                :key="index"
                class="clear_margin"
              >
                <dd>
                  <img
                    style="width:60px;height:60px;"
                    :src="item.icon"
                    alt
                  />
                </dd>
                <dt>{{item.schoolName}}</dt>
              </dl>
            </div>
            <div v-else class="school_list">
              <dl
                v-for="(item,index) in schoolList"
                @click="toNextPage(item)"
                :key="index"
                class="clear_margin"
              >
                <dd>
                  <img
                    style="width:60px;height:60px;"
                    :src="item.icon"
                    alt
                  />
                </dd>
                <dt>{{item.schoolName}}</dt>
              </dl>
            </div>
            <div class="bart">
              <ul>
                <li
                  v-for="(item,ind) in schooTabNum"
                  :class="ind == schoolTabInd?'bart_active':null"
                  @click="schoolTab(ind)"
                  :key="ind"
                ></li>
              </ul>
            </div>
          </div>
          <span v-if="schoolList.length > 10" class="school_right cursor_p" @click="toRight">
            <img style="width:40px;height:50px;" :src="isRight?require('../images/login/right.svg'):require('../images/login/right_gray.svg')" alt/>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="login_popup">
      <div class="back_prev">
        <img
          style="width:24px;height:24px;"
          @click="returnPrev()"
          src="../../src/images/login/ico_return.svg"
          alt
        />
      </div>
      <div class="next_box">
        <div class="school_icon">
          <dl>
            <dd>
              <img src="../../src/images/login/QRcode.svg" alt/>
            </dd>
            <dt>{{schoolName}}</dt>
          </dl>
        </div>
        <div class="login_message">
          <div class="login_input">
            <div class="user_inp">
              <input name="elseuser" type="text" maxlength="50" id="elseUser" placeholder="请输入账号"/>
            </div>
            <div class="pass_inp">
              <p class="forget_pass cursor_p">忘记密码</p>
              <input name="elsepass" type="text" maxlength="50" id="elsePass" placeholder="请输入密码"/>
              <span>
                <img src="../../src/images/login/hidepass.svg" alt/>
              </span>
            </div>
          </div>
          <div class="login_btn">
            <button class="cursor_p">登录</button>
          </div>
        </div>
      </div>
      <div class="else_login">
        <div class="else_box">
          <p class="else_tit">其他登录方式</p>
          <div class="learn_number" style="margin-top: 20px;">
            <button class="cursor_p">账号登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from 'axios';

export default {
  data() {
    return {
      start: 0,
      end: 10,
      chiceAfter: false,
      schoolList: [],
      originList: [],
      schooTabNum: 0,
      schoolTabInd: 0,
      schoolName: "", // 学校名称

      schoolSearch: "", // v-m 筛选学校

      /* 动态设置 左右按钮 */
      isLeft: false,
      isRight: true,
      schoolShowFlag: false,
    };
  },
  created() {
    this.getRenderData();
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == "schoolCode"){
        this.schoolShowFlag = true;
      }
    }
  },
  mounted() {},
  methods: {
    getRenderData(){
      const that = this;
      axios.get('https://pass.fifedu.com/iplat-pass/web/getWebLoginUrl?type=1')
        .then(function(res){
          if(res.status == 200){
            that.schoolList = res.data.data.schoolsInfo;
            that.originList = res.data.data.schoolsInfo;
            that.schooTabNum = Math.ceil(that.schoolList.length / 10);
            if(that.schoolList.length<10 && that.schoolList.length != 0){
              that.schooTabNum = 1;
            }
          }
        })
        .catch(function(err){
          console.log(err);
        });
    },
    searchTo(){
      var reSetList= [];
      if(this.schoolSearch == ''){
        this.schoolList = this.originList;
      }else{
        this.originList.forEach(item=>{
          if(item.schoolName.search(this.schoolSearch) != -1){
            reSetList.push(item);
          }
        })
        this.schoolList = reSetList;
      }
    },
    /* 底部bar切换 */
    schoolTab(key) {
      this.schoolTabInd = key;
      this.start = key * 10;
      this.end = this.start + 10;
    },
    toLeft() {
        // $(".school_right img").attr("src", this.right_img);
      this.isRight = true;
      if (this.end >= 20) {
        // $(".school_left img").attr("src", this.left_img);
        this.isLeft = true;
        this.start -= 10;
        this.end -= 10;
      }
      if (this.start / 10 == 0) {
        // $(".school_left img").attr("src", this.gray_left_img);
        this.isLeft = false;
      }
      this.schoolTab(this.start / 10);
    },
    toRight() {
      if (this.start / 10 == Math.floor(this.schoolList.length / 10) - 1) {
        // $(".school_right img").attr("src", this.gray_right_img);
        this.isRight = false;
      }
      if (this.start / 10 < Math.floor(this.schoolList.length / 10)) {
        // $(".school_left img").attr("src", this.left_img);
        this.isLeft = true;
        this.start = this.start += 10;
        this.end = this.end += 10;
      }
      this.schoolTab(this.start / 10);
    },
    /* 到下个页面 */
    toNextPage(data) {
      // this.chiceAfter = true; 
      window.open(data.url, "_blank");
    },
    /* 返回上个页面-选择 */
    returnPrev() {
      this.schoolName = "";
      this.chiceAfter = false;
    },
    /* 关闭学校列表 */
    closeList() {
      this.$emit("offSchoolList", false);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/elseView.vue